import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/rootReducer";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react/polaris";
import React from "react";
import { removeCacheableNotification } from "./cacheableNotificationConnector";
import moment from "moment/moment";

export const CacheableNotification = () => {
  const dispatch = useDispatch();
  const { notificationItems } = useSelector(
    (state: RootState) => state.cacheableNotification
  );
  const currentTimeMs = moment.now();
  const flashBarItems: FlashbarProps.MessageDefinition[] = Object.entries(
    notificationItems
  )
    .filter(([key]) => currentTimeMs - parseInt(key) < 30000)
    .map(([key, value]) => {
      return {
        ...value,
        id: key,
        onDismiss: () => dispatch(removeCacheableNotification(parseInt(key))),
      };
    });
  return <Flashbar items={flashBarItems} />;
};
